import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

function Contact() {
  const { lang } = useLanguage();

  return (
    <>
      <section className="page-hero">
        <h1><span className="gradient-text">{t(lang, 'contact_title')}</span></h1>
        <p>{t(lang, 'contact_subtitle')}</p>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>{t(lang, 'contact_info_title')}</h2>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div>
                  <h3>{t(lang, 'contact_address')}</h3>
                  <p>Red-Database-Security GmbH<br />Eibenweg 42<br />D-63150 Heusenstamm</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div>
                  <h3>{t(lang, 'contact_phone')}</h3>
                  <p>+49 (0)6821 – 95 17 637</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div>
                  <h3>{t(lang, 'contact_fax')}</h3>
                  <p>+49 (0)6821 – 91 27 354</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div>
                  <h3>{t(lang, 'contact_email')}</h3>
                  <p>info@red-database-security.com</p>
                </div>
              </div>
            </div>

            <div className="contact-form">
              <h2>{t(lang, 'contact_form_title')}</h2>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="form-group">
                  <label htmlFor="name">{t(lang, 'contact_name')}</label>
                  <input type="text" id="name" placeholder={t(lang, 'contact_name_placeholder')} />
                </div>
                <div className="form-group">
                  <label htmlFor="email">{t(lang, 'contact_email_label')}</label>
                  <input type="email" id="email" placeholder={t(lang, 'contact_email_placeholder')} />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">{t(lang, 'contact_subject')}</label>
                  <input type="text" id="subject" placeholder={t(lang, 'contact_subject_placeholder')} />
                </div>
                <div className="form-group">
                  <label htmlFor="message">{t(lang, 'contact_message')}</label>
                  <textarea id="message" placeholder={t(lang, 'contact_message_placeholder')}></textarea>
                </div>
                <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>{t(lang, 'contact_send')}</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
